// extracted by mini-css-extract-plugin
module.exports = {"bottom-menu":"BottomMenu_bottom-menu__JD5AF"};